import ts from "./custom-event-data.js";
import rs from "./custom-event-property-data.js";
import is from "./filter-set.js";
import ni from "./in-app-message-click-data.js";
import ns from "./purchase-data.js";
import hs from "./purchase-property-data.js";
import ur from "./push-click-data.js";
import tt from "./trigger-events.js";
import { logger as r } from "../../../shared-lib/index.js";
import { getErrorMessage as si } from "../../util/error-utils.js";
export default class ri {
  constructor(e, t) {
    (this.type = e), (this.data = t), (this.type = e), (this.data = t);
  }
  sc(e, t) {
    return ri.cc[this.type] === e && (null == this.data || this.data.Jl(t));
  }
  static rf(e, t) {
    let s = null;
    try {
      s = window.atob(e);
    } catch (t) {
      return r.info("Failed to unencode analytics id " + e + ": " + si(t)), !1;
    }
    return t === s.split("_")[0];
  }
  static fromJson(e) {
    const t = e.type;
    let r = null;
    switch (t) {
      case ri.Er.OPEN:
      case ri.Er.kt:
        break;
      case ri.Er.Rr:
        r = ns.fromJson(e.data);
        break;
      case ri.Er.nc:
        r = hs.fromJson(e.data);
        break;
      case ri.Er.vr:
        r = ur.fromJson(e.data);
        break;
      case ri.Er.ue:
        r = ts.fromJson(e.data);
        break;
      case ri.Er.lc:
        r = rs.fromJson(e.data);
        break;
      case ri.Er.Vr:
        r = ni.fromJson(e.data);
    }
    return new ri(t, r);
  }
  Y() {
    return { t: this.type, d: this.data ? this.data.Y() : null };
  }
  static qn(e) {
    let t,
      r = null;
    switch (e.t) {
      case ri.Er.OPEN:
      case ri.Er.kt:
        break;
      case ri.Er.Rr:
        r = new ns(e.d);
        break;
      case ri.Er.nc:
        (t = e.d || {}), (r = new hs(t.id, is.qn(t.pf || [])));
        break;
      case ri.Er.vr:
        r = new ur(e.d);
        break;
      case ri.Er.ue:
        r = new ts(e.d);
        break;
      case ri.Er.lc:
        (t = e.d || {}), (r = new rs(t.e, is.qn(t.pf || [])));
        break;
      case ri.Er.Vr:
        r = new ni(e.d);
    }
    return new ri(e.t, r);
  }
}
(ri.Er = {
  OPEN: "open",
  Rr: "purchase",
  nc: "purchase_property",
  vr: "push_click",
  ue: "custom_event",
  lc: "custom_event_property",
  Vr: "iam_click",
  kt: "test",
}),
  (ri.cc = {}),
  (ri.cc[ri.Er.OPEN] = tt.OPEN),
  (ri.cc[ri.Er.Rr] = tt.Rr),
  (ri.cc[ri.Er.nc] = tt.Rr),
  (ri.cc[ri.Er.vr] = tt.vr),
  (ri.cc[ri.Er.ue] = tt.ue),
  (ri.cc[ri.Er.lc] = tt.ue),
  (ri.cc[ri.Er.Vr] = tt.Vr),
  (ri.cc[ri.Er.kt] = tt.kt);
